import { selectEntitiesCompetitors } from '../../../../selectors/entities/competitors/entitiesCompetitorsPrimary.selector';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { type StateType } from '../../../../states';
import { type CompetitorState } from '../../../../states/entities/competitors';
import { type OutcomeState } from '../../../../states/entities/outcomes';
import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';

type LineUpRacerPropsType = {
  name?: string;
  imgSrc?: string;
};

export type LineUpRacerSelectorProps = {
  competitorId?: number;
};

export const selectLineUpCompetitor: Selector<CompetitorState | undefined> = (
  state: StateType,
  { competitorId }: LineUpRacerSelectorProps = {},
) => {
  const competitors = selectEntitiesCompetitors(state);
  return competitorId ? competitors[competitorId] : undefined;
};

const makeLineUpRacerPropsSelector: SelectorMaker<LineUpRacerPropsType> = () => {
  const selectLineUpCompetitorOutcome: Selector<OutcomeState | void> = (
    state: StateType,
    { competitorId }: LineUpRacerSelectorProps = {},
  ) => {
    const outcomes = selectEntitiesOutcomes(state);
    const outcomeId = Object.keys(outcomes).find(
      (outcome) => outcomes[parseInt(outcome)]?.competitorId === competitorId,
    );
    return outcomeId ? outcomes[parseInt(outcomeId)] : undefined;
  };

  const selectLineUpRacerName: Selector<string> = (state: StateType, props: LineUpRacerSelectorProps = {}) => {
    return selectLineUpCompetitorOutcome(state, props)?.label ?? '';
  };

  const selectLineUpRacerImg: Selector<string | undefined> = (
    state: StateType,
    props: LineUpRacerSelectorProps = {},
  ) => {
    return selectLineUpCompetitorOutcome(state, props)?.flag;
  };

  return createResultEqualSelector([selectLineUpRacerName, selectLineUpRacerImg], (name, imgSrc) => ({
    name,
    imgSrc,
  }));
};

export default makeLineUpRacerPropsSelector;
